'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Bubble = require('../Bubble-0f737416.js');
require('../tslib.es6-13d783d6.js');
require('react');
require('styled-components');
require('../CloseIcon-978b729e.js');
require('../typography/index.js');



Object.defineProperty(exports, 'BubbleType', {
	enumerable: true,
	get: function () {
		return Bubble.BubbleType;
	}
});
exports.bubbleHeightDefault = Bubble.bubbleHeightDefault;
exports.default = Bubble.Bubble;
//# sourceMappingURL=index.js.map
